import { render } from "./ReportAd.vue?vue&type=template&id=47997eb3"
import script from "./ReportAd.vue?vue&type=script&lang=js"
export * from "./ReportAd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__